import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';



/**
 * Generated class for the ContentPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-content',
  templateUrl: 'content.html',
})
export class ContentPage {

  content;
  sliderHeight: Number = (window.innerWidth * 9 / 21);

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.content = navParams.get('content');
    console.log(this.content);
  }

  contentColumnsInRow(row){
    const numCols = parseInt(row.number_of_columns);
    const cols = [
      row.column_editor.column_1.edit_content_column,
      row.column_editor.column_2.edit_content_column,
      row.column_editor.column_3.edit_content_column,
      row.column_editor.column_4.edit_content_column
    ].slice(0, numCols);
    return cols;
  }

  slideStyle(slide){
    return {
      height: `${this.sliderHeight}px`,
      background: `url(${slide.sizes.large}) no-repeat`,
      backgroundSize: 'cover',
      backgroundPosition: '50% 50%'
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ContentPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/content/content.ts